import { render, staticRenderFns } from "./code-add.vue?vue&type=template&id=5cc8bcb6&scoped=true"
import script from "./code-add.vue?vue&type=script&lang=js"
export * from "./code-add.vue?vue&type=script&lang=js"
import style0 from "./code-add.vue?vue&type=style&index=0&id=5cc8bcb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc8bcb6",
  null
  
)

export default component.exports